import classNames from 'classnames';
import Badge, { BadgeBg } from 'components/base/Badge';
import { Spinner } from 'react-bootstrap';
import './ProgressBadge.css';

type ProgressBadgeProps = {
  label: string;
  bg?: BadgeBg;
  title?: string;
  className?: string;
};

const ProgressBadge = ({
  label,
  bg = 'warning',
  title,
  className
}: ProgressBadgeProps) => (
  <Badge
    bg={bg}
    variant="phoenix"
    className={classNames('progress-badge fs-10', className)}
    title={title}
  >
    <Spinner
      animation="border"
      size="sm"
      className="progress-badge-spinner"
      role="status"
      aria-hidden="true"
    />
    <span className="progress-badge-label">{label}</span>
  </Badge>
);

export default ProgressBadge;
